import { gql } from '@apollo/client';

export const GET_INVENTORY_BY_SELLER = gql`
  query GetInventoryBySeller(
    $seller_id: String!,
    $from_date: String,
    $to_date: String,
    $status: String,
    $page: Int,
    $page_size: Int,
    $stock_type: String
  ) {
    getInventoryBySeller(
      seller_id: $seller_id,
      from_date: $from_date,
      to_date: $to_date,
      status: $status,
      page: $page,
      page_size: $page_size,
      stock_type: $stock_type
    ) {
      status
      message
      inventory_requests {
        inv_id
        status
        date
        create_date
        move_type
        stock_type
        scheduled_date
        date_demande
        date_prevue
        move_type_odoo
        stock_type_odoo
        inventory_list {
          ID
          Qty
          product_id
          quantity_done
        }
      }
      pagination {
        page
        page_size
        total_records
        total_pages
      }
    }
  }
`;
